module.exports = "/_next/static/images/ourPartnersAptitudeLogo-5736895b5a3fae698f893972b6d61809.webp";